import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import Menu from "@material-ui/icons/Menu";
import Close from "@material-ui/icons/Close";
import { BrowserView } from "react-device-detect";
import EmailIcon from "@material-ui/icons/Email";
import ReactFlagsSelect from "react-flags-select";
import "react-flags-select/css/react-flags-select.css";
import "react-flags-select/scss/react-flags-select.scss";

import logo from "../../assets/img/menergy.svg";
import { MailId } from "constants/Data";

import "./Header.scss";
import styles from "../../assets/jss/material-kit-pro-react/components/headerStyle";

const useStyles = makeStyles(styles);

export default function Header(props) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const classes = useStyles();
  React.useEffect(() => {
    if (props.changeColorOnScroll) {
      window.addEventListener("scroll", headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        window.removeEventListener("scroll", headerColorChange);
      }
    };
  });
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const headerColorChange = () => {
    const { color, changeColorOnScroll } = props;

    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[changeColorOnScroll.color]);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[changeColorOnScroll.color]);
    }
  };
  const { color, links, fixed, absolute } = props;

  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes[color]]: color,
    [classes.absolute]: absolute,
    [classes.fixed]: fixed
  });

  return (
    <AppBar
      className={appBarClasses}
      style={{ paddingTop: 0, flexDirection: "column" }}
    >
      <BrowserView
        style={{ width: "100%", backgroundColor: "#006978", color: "#fff" }}
      >
        <div className={classes.topFooter + " " + classes.container}>
          <ul
            className={classes.socialButtons}
            style={{ marginBottom: 0, paddingLeft: 0 }}
          >
            <li>
              <Link to="/">
                <Button style={{ color: "#fff" }}>
                  <i className="fab fa-twitter" />
                </Button>
              </Link>
            </li>
            <li>
              <Link to="/">
                <Button style={{ color: "#fff" }}>
                  <i className="fab fa-facebook-square" />
                </Button>
              </Link>
            </li>
            <li>
              <Link to="/">
                <Button style={{ color: "#fff" }}>
                  <i className="fab fa-dribbble" />
                </Button>
              </Link>
            </li>
            <li>
              <Link to="/">
                <Button style={{ color: "#fff" }}>
                  <i className="fab fa-google-plus-g" />
                </Button>
              </Link>
            </li>
            {/* <li>
              <Link to="/">
                <Button style={{ color: '#e52d27' }} >
                  <i className="fab fa-youtube" />
                </Button>
              </Link>
            </li> */}
          </ul>

          <div className={classes.contactInfo}>
            <h6
              style={{
                textTransform: "lowercase",
                display: "flex",
                alignItems: "center"
              }}
            >
              <EmailIcon style={{ fontSize: 14, marginRight: 10 }} />
              <a href={`mailto: ${MailId} `} style={{ color: "inherit" }}>
               {MailId}
              </a>
            </h6>
            {/* <h6 style={{ display: 'flex', alignItems: 'center', marginLeft: 30 }}>
              <PhoneIcon style={{ fontSize: 14, marginRight: 10 }} />
              <a href="tel:+(111) 111-11-11" style={{ color: 'inherit' }}> + (111) 111-11-11</a>
            </h6> */}
            <ReactFlagsSelect
              defaultCountry="IE"
              countries={["IE"]}
              disabled
            />
          </div>
        </div>
      </BrowserView>
      <Toolbar className={classes.container}>
        <Button className={classes.title}>
          <Link to="/">
            <img src={logo} className="imgWidth" alt="logo" />
          </Link>
        </Button>
        <Hidden mdDown implementation="css" className={classes.hidden}>
          <div className={classes.collapse}>{links}</div>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            style={{ cursor: "pointer", color: "darkgray" }}
          >
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
      <Hidden lgUp implementation="js">
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={mobileOpen}
          classes={{
            paper: classes.drawerPaper
          }}
          onClose={handleDrawerToggle}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            className={classes.closeButtonDrawer}
          >
            <Close />
          </IconButton>
          <div className={classes.appResponsive}>{links}</div>
        </Drawer>
      </Hidden>
    </AppBar>
  );
}

Header.defaultProp = {
  color: "white"
};

Header.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark",
    "blackColor"
  ]),
  links: PropTypes.node,
  // brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark",
      "blackColor"
    ]).isRequired
  })
};
